// extracted by mini-css-extract-plugin
export default {"teamContainer":"TeamSection_teamContainer__f+C5R","carouselContainer":"TeamSection_carouselContainer__GsRtx","cardContainer":"TeamSection_cardContainer__frCmn"};